export default {
  // Page title
  title: "Auto Push Configuration",

  // Search form
  searchForm: {
    pushTitle: "Push Title",
    pushTitlePlaceholder: "Please enter",
    language: "Language",
    languagePlaceholder: "Please select",
    pushSwitch: "Push Switch",
    pushSwitchPlaceholder: "Please select",
    search: "Search",
    reset: "Reset",
    add: "Add New"
  },

  // Table column titles
  table: {
    pushType: "Push Type",
    subType: "Sub-type",
    pushTitle: "Push Title",
    pushContent: "Push Content",
    jumpPath: "Jump Path",
    language: "Language",
    pushSwitch: "Push Switch",
    inboxPushSwitch: "Inbox Message Switch",
    inboxMessageType: "Inbox Message Type",
    operation: "Operation",
    edit: "Edit",
    delete: "Delete"
  },

  // Push types
  pushTypes: {
    recharge: "Recharge",
    withdrawal: "Withdrawal",
    vipReward: "VIP Reward",
    activityOffer: "Activity Offer",
    kyc: "KYC"
  },

  // Sub types
  subTypes: {
    onlineRecharge: "Online Recharge",
    manualRecharge: "Manual Recharge",
    onlineWithdrawal: "Online Withdrawal",
    manualWithdrawal: "Manual Withdrawal",
    upgradeBonus: "Upgrade Bonus",
    retentionBonus: "Retention Bonus",
    weeklySalary: "Weekly Salary",
    monthlySalary: "Monthly Salary",
    birthdayBonus: "Birthday Bonus",
    kycVerification: "KYC Verification",
    manualRechargePoints: "Manual Points Credit",
    manualDeductPoints: "Manual Points Deduction",
    upgradePoints: "Upgrade Points",
    retentionPoints: "Retention Points",
    h5DailyPoints: "H5 Daily Points",
    appDailyPoints: "App Daily Points",
    bettingRebate: "Betting Rebate",
    realtimeRebate: "Real-time Rebate",
    registrationOffer: "Registration Offer",
    dailyFirstDeposit: "Daily First Deposit",
    rechargeOffer: "Recharge Offer",
    manualIssue: "Manual Issue",
    everyDepositOffer: "Every Deposit Offer",
    firstDepositOffer: "First Deposit Offer"
  },

  // Push switch status
  pushSwitch: {
    enabled: "Enabled",
    disabled: "Disabled"
  },

  // Modal
  modal: {
    addTitle: "Add New",
    editTitle: "Edit",
    pushType: "Push Type",
    pushTypePlaceholder: "Please select",
    subType: "Sub-type",
    subTypePlaceholder: "Please select",
    notificationTitle: "Notification Title",
    notificationTitlePlaceholder: "Within 50 characters",
    memberType: "Member Type",
    memberTypePlaceholder: "Please select member type",
    loginChannel: "Login Channel",
    loginChannelPlaceholder: "Please select",
    notificationContent: "Notification Content",
    notificationContenttips: ' (If the push content involves amounts or other variables, please use {0} format to add)',
    notificationContentPlaceholder: "Within 1000 characters",
    selectLanguage: "Select Language",
    languagePlaceholder: "Please select",
    jumpPath: "Jump Path",
    jumpPathPlaceholder: "Please enter jump path",
    pushSwitch: "Push Switch",
    inboxPushSwitch: "Inbox Message Push Switch",
    inboxMessageType: "Inbox Message Type",
    inboxMessageTypePlaceholder: "Please select inbox message type",
    enable: "Enable",
    disable: "Disable",
    confirm: "Confirm",
    cancel: "Cancel"
  },

  // Validation messages
  validation: {
    pushTypeRequired: "Please select push type",
    subTypeRequired: "Please select sub-type",
    notificationTitleRequired: "Please enter notification title",
    notificationContentRequired: "Please enter notification content",
    notificationContentPattern: "Notification content must include {0-9} format",
    languageRequired: "Please select language",
    inboxMessageTypeRequired: "Please select inbox message type"
  },

  // Scheduled send (all members)
  schedule: {
    title: "Scheduled Send Settings",
    sendDate: "Auto Send Date",
    sendDateRequired: "Please select the auto send date",
    dailyTime: "Daily Send Time",
    dailyTimeRequired: "Please select the daily send time",
    fillWarning: "Please fill in the auto send date and daily send time"
  },

  // Operation messages
  messages: {
    addSuccess: "Added successfully",
    updateSuccess: "Updated successfully",
    deleteSuccess: "Deleted successfully",
    deleteFailed: "Delete failed",
    fetchDataFailed: "Failed to fetch data",
    confirmDelete: "Confirm Delete",
    confirmDeleteContent: "Are you sure you want to delete push configuration \"{title}\"?"
  }
};
